// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3L14C","image":"Header_image__15rHZ","name":"Header_name__3Yy6e","info":"Header_info__2xqld","infoRow":"Header_infoRow__18fJk"};